import * as React from 'react';

import { BreakpointSizeType } from '../../../../theme/type/breakpoints-type';

export interface TableBodyPropsInterface {
    children: React.ReactElement[] | React.ReactElement;
    mobileBreakUnder?: BreakpointSizeType;
    isScrolled?: boolean;
    isScrollable?: boolean;
    isScrollOnEnd?: boolean;
    locked?: boolean;
    border?: boolean;
}

export const TableBody: React.FC<TableBodyPropsInterface> = ({
    children,
    mobileBreakUnder,
    isScrolled,
    isScrollable,
    isScrollOnEnd,
    border,
    locked,
}) => {
    if (Array.isArray(children)) {
        return (
            <tbody className="border-0">
                {children.map((child, index: number) => {
                    return React.cloneElement(child, {
                        mobileBreakUnder,
                        isScrolled,
                        isScrollable,
                        isScrollOnEnd,
                        locked,
                        border,
                        ...child.props,
                        key: index,
                    });
                })}
            </tbody>
        );
    }

    return (
        <tbody className="border-0">
            {React.cloneElement(children, {
                mobileBreakUnder,
                isScrolled,
                isScrollable,
                isScrollOnEnd,
                locked,
                border,
                ...children.props,
            })}
        </tbody>
    );
};
